import React from "react";
import PropTypes from "prop-types";
//Material imports
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import makeStyles from "@mui/styles/makeStyles";
const useClasses = makeStyles(theme => ({
  iconContainer: {
    "&:hover": {
      color: theme.palette.secondary.main
    }
  }
}));
const TableAddNewIcon = ({
  title,
  onClick,
  children
}) => {
  const classes = useClasses();
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    className: classes.iconContainer,
    size: "large"
  }, children));
};
export default TableAddNewIcon;
TableAddNewIcon.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};